module.exports = __webpack_public_path__ + "img/andriod.af8b8fb0.svg";